module.exports = __webpack_public_path__ + "img/company-update.268de48e.svg";